export default theme => ({

  root: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    opacity: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    transition: 'opacity 0.5s ease-in-out'
  },

  ready: {
    opacity: 1
  },

  paper: {
    minHeight: '100%'
  }

});




// WEBPACK FOOTER //
// ./src/styles/components/App.js